import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
import SysUtils from '@/base/utils/SysUtils'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

mutations.getAllChapters = function (state, payload) {
  state.allChaptersList = payload
}
mutations.getAllPendingTitle = function (state, payload) {
  state.allPendingTitleList = payload
}
mutations.getAllQuestionsAndAnswers = function (state, payload) {
  state.allQuestionsAndAnswers = payload
}

const state = {
  allChaptersList: [],
  allPendingTitleList: [],
  allQuestionsAndAnswers: []
}
const actions = {
  init: ({ commit, state }) => {
    const ctx = {
      data: {
        getAllChapters: {api: 'M0201ChapterService.getAllChapters'},
        getAllPendingTitle: {api: 'M0202TitleService.getAllPendingTitle'}
      }
    }

    return client.postData(ctx)
      .then((data) => {
        if (SysUtils.isEmpty(data.getAllChapters.output)) {
          alert('no match record')
        }
        commit('getAllChapters', data.getAllChapters.output)
        commit('getAllPendingTitle', data.getAllPendingTitle.output)
      })
  },
  change_chapter_status: ({ commit, state }, chapterDetail) => {
    console.debug('called M0201Chapter change')
    return client.postData({ data: { change_chapter_status: { api: 'M0201ChapterService.changeChapterStatus', input: chapterDetail } } })
      .then((data) => {
        if (SysUtils.isEmpty(data.change_chapter_status.output)) {
          alert('no match record')
        }
        commit('getAllChapters', data.change_chapter_status.output)
      })
  },
  getAllQuestionsAndAnswers: ({ commit, state }, titleID) => {
    console.debug('called M0203QuestionService search')
    return client.postData({ data: { getAllQuestionsAndAnswers: { api: 'M0203QuestionService.getAllQuestionsAndAnswers', input: titleID } } })
      .then((data) => {
        commit('getAllQuestionsAndAnswers', data.getAllQuestionsAndAnswers.output)
      })
  },
  doUpdateTitleStatus: ({ commit, state }, titleDetails) => {
    console.debug('called M0203QuestionService search')
    return client.postData({ data: { save: { api: 'M0202TitleService.updateTitleStatus', input: titleDetails } } })
      .then((data) => {
        commit('getAllQuestionsAndAnswers', [])
        commit('getAllPendingTitle', data.save.output)
      })
  }

}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module



// WEBPACK FOOTER //
// ./src/components/functions/M0201Chapter/M0201ChapterStore.js